import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import { Spinner } from "@fellowflats/ui";
import "./index.css";
import { AuthProvider, useAuth } from "./lib/auth";
import { Layout } from "./components/layout";
import { SignIn } from "./pages/sign-in";
import { Factor } from "./pages/factor";
import { Overview } from "./pages/overview";
import { Listings } from "./pages/listings";
import { ListingEditor } from "./pages/listing";
import { Verifications } from "./pages/verifications";
import { Reports } from "./pages/reports";
import { People } from "./pages/people";
import { Leads } from "./pages/leads";
import { Analytics } from "./pages/analytics";
import { Jobs } from "./pages/jobs";

/** Nothing of the CRM renders until the session has its second factor. */
function Gate() {
  const { stage } = useAuth();
  if (stage === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (stage === "signed-out") return <SignIn />;
  if (stage === "needs-factor") return <Factor />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Overview />} />
        <Route path="listings" element={<Listings />} />
        <Route path="listings/:id" element={<ListingEditor />} />
        <Route path="verifications" element={<Verifications />} />
        <Route path="reports" element={<Reports />} />
        <Route path="people" element={<People />} />
        <Route path="leads" element={<Leads />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="*" element={<Overview />} />
      </Route>
    </Routes>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
